export enum PROJECT_CREATION_LEVELS {
  COMPOSITIONS = 'compositions',
  ARTICLES = 'articles',
  PARTS = 'parts',
  ACCESSORIES = 'accessories',
}
